/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2021, Zumper
 * @description   HomepageHeroMobile
 */

/** @jsx jsx */
import { Box, Heading, Text, useColorModeValue } from '@chakra-ui/react'
import { jsx } from '@emotion/react'
import { default as MobileAutocompleteInput } from '../../Autocomplete/MobileSearchAutocomplete/MobileAutocompleteInput'
import {
  HEADER_TEXT,
  HEADER_TEXT_ZUMPER_RENTALS,
  NEW_AUTOCOMPLETE_PLACEHOLDER,
  SUBHEADER_TEXT,
  SUBHEADER_TEXT_ZUMPER_RENTALS,
} from '../constants'
import * as styles from './style'

export interface Props {
  homepageMainSearch: 'top-search'
  isZumperRentals: boolean
  onClickSearchForm: () => void
}

export const HomepageHeaderMobile = ({
  homepageMainSearch,
  isZumperRentals,
  onClickSearchForm,
}: Props) => {
  const bgColor = useColorModeValue('#f4f1ea', 'blue.900')
  const subText = useColorModeValue('gray.600', 'gray.300')
  const placeholder = NEW_AUTOCOMPLETE_PLACEHOLDER
  return (
    <Box<'div'> bg={bgColor} css={styles.mobileContainer}>
      <div css={styles.headerContent}>
        <div css={styles.textContainer}>
          <Heading<'h2'>
            variant="display40To48"
            maxW={isZumperRentals ? { base: '327px', desktop: '250px' } : '250px'}
            textAlign="center"
            marginBottom={3}
          >
            {isZumperRentals ? HEADER_TEXT_ZUMPER_RENTALS : HEADER_TEXT}
          </Heading>
          <Text<'h1'>
            as="h1"
            variant="body20Reg"
            maxW="328px"
            textAlign="center"
            lineHeight={7}
            letterSpacing="-0.5px"
            color={subText}
          >
            {isZumperRentals ? SUBHEADER_TEXT_ZUMPER_RENTALS : SUBHEADER_TEXT}
          </Text>
        </div>
        <div css={styles.formContainer} data-testid="searchField" onClick={onClickSearchForm}>
          <MobileAutocompleteInput
            isShortTerm
            mobileOrigin={homepageMainSearch}
            placeholder={placeholder}
          />
        </div>
      </div>
    </Box>
  )
}
